import * as SettingsModules from "./Settings/Modules";
import * as Users from "./Settings/Users";
import * as Login from "./Login";
import * as Calendar from "./Calendar";
import * as CalendarGuests from "./Calendar/CalendarGuests";
import * as CalendarNotifications from "./Calendar/CalendarNotifications";
import * as BusinessHours from "./Settings/BusinessHours";
import * as Status from "./Settings/Status";
import * as POSCategories from "./Settings/POSCategories";
import * as Types from "./Settings/Types";
import * as Flows from "./Settings/Flows";
import * as FlowTasks from "./Settings/FlowTasks";
import * as ContactTypes from "./Settings/ContactTypes";
import * as FileLocations from "./Settings/FileLocations";
import * as InvoicingIssuers from "./Settings/InvoicingIssuers";
import * as Products from "./Settings/Products";
import * as Configurations from "./Settings/Configurations";
import * as Visitors from "./Management/Visitors";
import * as Customers from "./Management/Customers";
import Modules from "./Modules";
import * as Log from "./General/Log";
import * as PendingPayments from "./General/PendingPayments";
import * as Storage from "./General/Storage";
import * as TransactionalFlows from "./Workflows/TransactionalFlows";
import * as TransactionalFlowTasks from "./Workflows/TransactionalFlowTasks";
import * as TransactionalFlowTaskComments from "./Workflows/TransactionalFlowTaskComments";
import * as TransactionalFlowTaskActivity from "./Workflows/TransactionalFlowTaskActivity";
import Chat from "./Conversations";
import * as POSEntriesMaster from "./POSEntries/Master";
import * as POSEntriesDetail from "./POSEntries/Detail";
import * as POSEntriesReports from "./POSEntries/Reports";
import * as Invoices from "./Invoicing/Invoices";
import * as InvoiceDetails from "./Invoicing/InvoiceDetails";
import * as Forms from "./Forms/Forms";
import * as FormClients from "./Forms/FormClients";

const api = {
    Settings: {
        Modules: SettingsModules,
        Users,
        BusinessHours,
        Status,
        Types,
        ContactTypes,
        FileLocations,
        Flows,
        FlowTasks,
        POSCategories,
        InvoicingIssuers,
        Products,
        Configurations,
    },
    Login,
    Management: {
        Visitors,
        Customers,
    },
    Modules,
    General: {
        Log,
        Storage,
        PendingPayments,
    },
    Workflows: {
        Workflows: TransactionalFlows,
        Tasks: TransactionalFlowTasks,
        Comments: TransactionalFlowTaskComments,
        Activity: TransactionalFlowTaskActivity,
    },
    Calendar: {
        Events: Calendar,
        Guests: CalendarGuests,
        Notifications: CalendarNotifications,
    },
    Chat,
    POSEntries: {
        Master: POSEntriesMaster,
        Detail: POSEntriesDetail,
        Reports: POSEntriesReports,
    },
    Invoicing: {
        Invoices,
        InvoiceDetails,
    },
    Forms: {
        Forms,
        FormClients,
    },
};

export default api;
